import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleUser, faHouse, faRightFromBracket, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


library.add(faCircleUser, faHouse, faRightFromBracket, faCaretDown);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false

Vue.prototype.$baseAPI = process.env.VUE_APP_API_BASE_URL;
Vue.prototype.$login = process.env.VUE_APP_LOGIN_URL;
Vue.prototype.$redirect = process.env.VUE_APP_REDIRECT;

new Vue({
	vuetify,
	render: h => h(App)
}).$mount('#app')
